export default __webpack_public_path__ + "static/media/profile_2.fff37297.png";